/* eslint-disable no-unused-vars */
import { qryPayUrl, genCaptcha, validCaptcha, qryAllStates, qrySubsDetail } from '@pages/OnlinePayment/QueryBillingInformation/services';
import { get } from 'lodash';
import { getRequestData } from '@/utils';

const initState = {
  imgReturn: {},
};

export default {
  namespace: 'queryBillingInformation',
  state: {
    ...initState,
  },
  effects: {
    // 根据号码查询账单信息
    *qryPayUrl({ payload }, { call, put }) {
      const response = yield call(qryPayUrl, payload);
      const result = get(response, 'data') || {};
      return result;
    },

    // 生成图形验证码
    *genCaptcha(_, { call, put }) {
      const response = yield call(genCaptcha);
      const { imgCode, imgToken } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          imgReturn: {
            imgCode,
            imgToken,
          },
        },
      });
    },

    *qryAllStates(_, { call, put }) {
      const payload = { addressLevel: 'DOWN' };
      const response = yield call(qryAllStates, payload);
      // console.log('response', response);
      if (response.data && (response.data.code === 200 || response.data.code === '200')) {
        return response.data.data.addrs;
      }
      return [];
    },

    * qrySubsDetail({ payload }, { call, put }) {
      const response = yield call(qrySubsDetail, payload);
      const { subsDto = {}, returnMsg, returnCode } = getRequestData(response, false);

      // 处理 subsDto.installationAddressDto 使其结构和地址列表的接口返回的接口一致
      const { houseNo, road, landmark, latitude, longitude, pinCode, state, district, mainLocalityCode, subLocalityCode, poaDto } = get(subsDto, 'installationAddressDto') || {};
      subsDto.installationAddressDto = pinCode ? {
        ...(get(subsDto, 'installationAddressDto') || {}),
        address1: road,
        address2: houseNo,
        postCode: pinCode,
        addrExtMap: {
          state,
          district,
          mainLocalityCode,
          subLocalityCode,
          landMark: landmark,
          latitude,
          longitude,
          poaDto,
        },
      } : undefined;
      if (returnCode !== '0') { message.error(returnMsg); }
      return subsDto;
    },

    // 根据号码查询账单信息
    *validCaptcha({ payload }, { call }) {
      const response = yield call(validCaptcha, payload);
      const { returnCode } = getRequestData(response);
      if (returnCode === '0') {
        return true;
      }
      return false;
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
